import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { LOOKUP_REQUEST, saveLookupState } from './actions.js';
import { lookupExists, getLookupAction, getLookupOptions } from './config.js';
import { getLookupState } from './selectors.js';
import { ConcurrentPromiseMap } from '../utility/promise.js';

var lookupPromises = new ConcurrentPromiseMap();

var lookupMiddleware = function lookupMiddleware() {
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === LOOKUP_REQUEST) {
          // ensure the lookup is registered
          if (!lookupExists(action.name)) {
            var error = "Lookup \"".concat(action.name, "\" has not been registered");
            console.error(error);
            return Promise.resolve({
              success: false,
              error: error
            });
          } // get required lookup info


          var lookupAction = getLookupAction(action.name);

          var lookupOptions = _objectSpread2(_objectSpread2({}, getLookupOptions(action.name)), action.options);

          var lookupState = getLookupState(store.getState());
          var promiseKey = "".concat(action.name, "/").concat(action.key); // re-use state data if caching

          if (lookupOptions.cache && lookupState[action.name] && lookupState[action.name][action.key] && lookupState[action.name][action.key].response) {
            var useCache = true;
            var dataState = lookupState[action.name][action.key];
            var cacheDate = dataState.date; // check cache hasn't expired

            if (cacheDate && lookupOptions.cacheExpiry) {
              var expiryDate = cacheDate + lookupOptions.cacheExpiry;
              if (expiryDate < Date.now()) useCache = false;
            }

            if (useCache) {
              return Promise.resolve({
                success: true,
                response: dataState.response
              });
            }
          } // the process of requesting a lookup is promise-able so if
          // multiple simultaneous requests we only perform the lookup once


          var requestLookup = function requestLookup() {
            return new Promise(function (resolve) {
              var saveFailure = false;

              var saveLookup = function saveLookup(newState) {
                // ensure the lookup is still registered
                if (!lookupExists(action.name)) {
                  if (!saveFailure) {
                    console.warn("Lookup \"".concat(action.name, "\" unregistered before request finished"));
                  }

                  saveFailure = true;
                  return;
                }

                var limit = lookupOptions.cache ? lookupOptions.cacheLimit === undefined || isNaN(lookupOptions.cacheLimit) ? undefined : lookupOptions.cacheLimit : 1;
                store.dispatch(saveLookupState(action.name, action.key, limit, newState));
              };

              saveLookup({
                loading: true,
                slowLoading: false,
                params: action.params
              });
              var slowTimeout = setTimeout(function () {
                saveLookup({
                  loading: true,
                  slowLoading: true
                });
              }, 200);
              store.dispatch(typeof lookupAction === "function" ? lookupAction(action.params) : lookupAction).then(function (_ref) {
                var success = _ref.success,
                    rawResponse = _ref.response,
                    error = _ref.error;
                clearTimeout(slowTimeout);
                var response = success && rawResponse && lookupOptions.transform ? lookupOptions.transform(rawResponse, action.params) : rawResponse;
                saveLookup({
                  loading: false,
                  slowLoading: false,
                  date: Date.now(),
                  response: response,
                  error: error
                });
                resolve({
                  success: success,
                  response: response,
                  error: error
                });
              });
            });
          };

          return lookupPromises.resolve(promiseKey, requestLookup);
        }

        return next(action);
      };
    };
  };
};

var lookupMiddleware$1 = lookupMiddleware;

export { lookupMiddleware$1 as default };
